import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Grid,
  TextField,
  Button,
  Divider,
  DialogTitle,
} from "@mui/material";
import { ModalHeader } from "../../common/modalHeader.jsx";
import CloseIcon from "@mui/icons-material/Close";
const UpdateComponentModal = ({
  open,
  setOpen,
  title = "Modal Title",
  fields = [],
  onSubmit,
  initialData = {},
}) => {
  const [formData, setFormData] = useState(initialData);
  const handleSubmit = () => {
    onSubmit(formData);
    close();
  };

  const close = () => {
    setOpen(false);
  };

  useEffect(() => {
    setFormData(initialData);
  }, [open, initialData]);

  return (
    <Modal open={open} onClose={close}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { sm: 400, xs: 300 },
          bgcolor: "background.paper",
          boxShadow: 24,
          // p: 2,
          borderRadius: 2,
        }}
      >
        {/* <ModalHeader title={title} onClose={() => setOpen(false)} /> */}
        <DialogTitle
          color="primary"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: "600",
            padding: "10px 15px",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
        >
          {title}
          <CloseIcon
            sx={{
              float: "right",
              color: "#000000",
              fontSize: { xs: "15px", sm: "15px", md: "30px" },

              cursor: "pointer",
            }}
            onClick={() => setOpen(false)}
          />
        </DialogTitle>
        <Divider sx={{ borderBottom: "1px solid #01008B" }} />
        <Grid container spacing={2} sx={{ p: 2 }}>
          {fields.map((field, index) => (
            <Grid item xs={12} key={index}>
              <TextField
                fullWidth
                label={field.label}
                size="small"
                // sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                value={formData[field.name] || ""}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    [field.name]:
                      field.type === "number"
                        ? Number(e.target.value)
                        : e.target.value,
                  });
                }}
                placeholder={field.placeholder || ""}
                type={field.type === "number" ? "text" : field.type || "text"}
                onInput={
                  field.type === "number"
                    ? (e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }
                    : undefined
                }
                InputProps={{
                  classes: { input: "mulish" },
                  // fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              />
            </Grid>
          ))}
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
          {/* <Button onClick={close} color="secondary" sx={{ mr: 1 }}>
                        Cancel
              </Button> */}
          <Button
            sx={{
              width: "70%",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
            onClick={handleSubmit}
            color="primary"
            variant="contained"
          >
            Update
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UpdateComponentModal;
